import gql from "graphql-tag";

export default gql`
  mutation CreatePart(
    $name: String!
    $description: String
    $category: String
    $barcode: String
    $quantity: String
    $additionalPartDetails: String
    $siteId: ID
    $companyId: ID!
  ) {
    createPart(
      name: $name
      description: $description
      category: $category
      barcode: $barcode
      quantity: $quantity
      additionalPartDetails: $additionalPartDetails
      siteId: $siteId
      companyId: $companyId
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/CreatePart.ts